import { z } from 'zod';

// Which optional fields the organization's public referral web form displays.
// Display-only: the referral REST API accepts the corresponding fields for
// EVERY organization regardless of these settings (the numeric ids / field
// names are the stable contract; the form is just one client).
//
// This group is served world-readable to the unauthenticated referral forms
// via GET /organizations/{id}/referral-form-settings — only ever put
// form-display flags in here, never channels, emails or internal config.
export const ReferralFormSettingsSchema = z.strictObject({
  // Offer the telephone call as the patient's consent evidence: the
  // referrer says the member wants to be phoned before their account is
  // created, and the referral waits until we have asked them
  // (consent.patient.referral.evidence === 'phone-call').
  showPatientConsentPhoneCall: z.boolean(),
});

export type ReferralFormSettings = z.infer<typeof ReferralFormSettingsSchema>;
